import { UserProvider, useUser } from './UserContext';
import { ThemeProvider, useTheme } from './ThemeContext';
import { EventsProvider, useEventsContext } from './EventsContext';

export const WiloutProvider = ({ children }) => (
  <UserProvider>
    <ThemeProvider>
      <EventsProvider>
        {children}
      </EventsProvider>
    </ThemeProvider>
  </UserProvider>
);

export const useWilout = () => {
  const { user, setUser, logout } = useUser();
  const { theme, setTheme, toggleTheme } = useTheme();
  const {
    events,
    eventsLoading,
    eventsError,
    isRefreshing,
    refetchEvents,
    refreshEvents,
    refreshAllData,
    updateEventInState,
    hasMore,
    loadingMore,
    loadMore
  } = useEventsContext();

  return {
    user,
    setUser,
    theme,
    setTheme,
    toggleTheme,
    logout,
    events,
    eventsLoading,
    eventsError,
    isRefreshing,
    refetchEvents,
    refreshEvents,
    refreshAllData,
    updateEventInState,
    hasMore,
    loadingMore,
    loadMore
  };
};

